import { createSelector } from 'reselect';

const contactTypes = (state) => state.publisherContactTypes;

export const getContactTypes = createSelector(
    contactTypes,
    (contactTypes = []) => {
        return contactTypes.map((item) => {
                return {
                    value: item.name,
                    title: item.title,
                    disabled: item.supported
                };
            })
    }
);